import { useEffect, useRef, useState } from "react";
import { FeedbackConstant, FeedbackValues } from "../../../NewConstants/FeedbackConstants";

const FeedbackChatBlock = ({
    feedback,
    sendFeedback = () => { },
    disabled = false,
    resetKey,
}) => {
    const [submitted, setSubmitted] = useState(false);
    const sentRef = useRef(false);

    useEffect(() => {
        sentRef.current = false;
        setSubmitted(false);
    }, [resetKey]);

    const isFeedbackChosen = (value) =>
        value === FeedbackValues.LIKE || value === FeedbackValues.DISLIKE;

    const locked = disabled || submitted || isFeedbackChosen(feedback);

    const feedbackImageForOption = (option, feedbackValue) => {
        if (feedbackValue === FeedbackValues.LIKE && option.value === FeedbackValues.LIKE) {
            return "ThumbsUpFill.svg";
        }
        if (feedbackValue === FeedbackValues.DISLIKE && option.value === FeedbackValues.DISLIKE) {
            return "ThumbsDownFill.svg";
        }
        return option.image;
    };

    const onOptionClick = (option) => {
        if (disabled || isFeedbackChosen(feedback) || sentRef.current) return;
        sentRef.current = true;
        setSubmitted(true);
        sendFeedback(option);
    };

    return (
        <div
            className={`w-full h-full flex items-center justify-evenly ${locked ? "pointer-events-none opacity-60" : ""}`}
        >
            {FeedbackConstant.options.map((option, idx) => {
                const imageName = feedbackImageForOption(option, feedback);
                return (
                    <div
                        key={idx}
                        className="flex items-center justify-center"
                        onClick={() => onOptionClick(option)}
                    >
                        <img src={"./Assets/Images/" + imageName} alt="option" />
                    </div>
                );
            })}
        </div>
    );
};

export default FeedbackChatBlock;